@if (!isHidden) {
  <forge-icon-button (click)="executeAction($event)" [disabled]="isViewOnly" focusOnLoad [propertyMetadata]="propertyMetadata"
    [forCellEdit]="forCellEdit" attr.telemetry="Submission-{{Tooltip}}" (keydown)="handleKeyDown($event)"
    [ngClass]="{'cell-edit-icon-button': forCellEdit}" attr.aria-label="{{Tooltip}}">
    <forge-tooltip placement="bottom">{{Tooltip}}</forge-tooltip>
    <forge-icon [name]="Icon"></forge-icon>
  </forge-icon-button>
}
